import { html, render } from "lit-html";
import { store } from "./DataStore";
import { repeat } from "lit-html/directives/repeat.js";
import connect from "../../../shared/data-store/connect";
import "../hotel-list/Hotel";

customElements.define(
	"esc-favorites-hotel-list",
	class extends connect(HTMLElement, store) {
		constructor() {
			super();
			this.innerHTML = ""; // Clear html placeholders.
		}

		update(state, { sortedHotels }) {
			render(this.render(sortedHotels), this);
		}

		render(hotels) {
			// @TODO: extract this to a different widget and share with the article
			// hotel list.
			if (hotels.length === 0) {
				return repeat(
					["a", "b", "c"],
					id => id,
					() => html`
						<div class="hotel-list-item hotel-list-item--placeholder">
							<div class="hotel-list-item-desktop__container hidden-mobile">
								<div class="hotel-list-item-desktop__picture">
									<div class="content-placeholder"></div>
								</div>
								<div class="hotel-list-item-desktop__data">
									<div
										class="hotel-list-item-desktop__min-price-box content-placeholder"
									></div>
								</div>
							</div>

							<div
								class="hotel-list-item-mobile__picture-link hidden-tablet hidden-desktop hidden-cinema"
							>
								<div class="picture-gallery__image content-placeholder"></div>
							</div>
							<div
								class="hotel-list-item-mobile__description hidden-tablet hidden-desktop hidden-cinema"
							>
								<div class="hotel-list-item-mobile__classification">
									<span class="content-placeholder"></span>
								</div>
								<div class="hotel-list-item-mobile__location-name">
									<span class="content-placeholder"></span>
								</div>
								<div class="hotel-list-item-mobile__name-container">
									<span class="content-placeholder"></span>
								</div>
								<div class="hotel-list-item__criteria-placeholder">
									<span
										class="hotel-list-item__criterion content-placeholder"
									></span>
									<span
										class="hotel-list-item__criterion content-placeholder"
									></span>
									<span
										class="hotel-list-item__criterion content-placeholder"
									></span>
									<span
										class="hotel-list-item__criterion content-placeholder"
									></span>
								</div>
							</div>
							<div
								class="hotel-list-item-mobile__offers hidden-tablet hidden-desktop hidden-cinema"
							>
								<div
									class="hotel-list-item-mobile__offer hotel-list-item-mobile__offer--cta"
								>
									<div class="content-placeholder"></div>
								</div>
							</div>
						</div>
					`,
				);
			}

			return repeat(
				hotels,
				hotel => hotel.id,
				hotel =>
					html`<esc-hotel class="hotel-list-item" .hotel=${hotel}></esc-hotel>`,
			);
		}
	},
);
